<div class="bn-container d-flex flex-column h-100">
  <bn-web-ui-steps-component
    [nextStepEnabled]="true"
    [setStep]="selectedStepIndex() - 1"
    [stepItems]="stepItems"
    [withNextButton]="true"
    (selectedIndexChangedEvent)="onStepClick($event)">
    @if (selectedStepIndex() === 1) {
      <app-shield-setup-start
        class="my-4"
        (setupClick)="startSetup()">
        <div>First step</div>
      </app-shield-setup-start>
    }

    @if (selectedStepIndex() === 2) {
      <app-shield-setup-platform
        class="my-4"
        [selectedProfileId]="selectedShieldWafProfileId"
        [setShieldProfiles]="profiles"
        (selectShieldProfile)="setShieldProfile($event)" />
    }

    @if (selectedStepIndex() === 3) {
      <app-shield-setup-package
        class="my-4"
        [setSelectedShieldProfile]="selectedShieldProfile"
        (selectShieldPackage)="setShieldPackage($event)" />
    }

    @if (selectedStepIndex() === 3) {
      <div class="mt-auto d-flex justify-content-end">
        <button
          bn-web-ui-button
          class="mt-2"
          itemStyle="primary"
          size="xl"
          type="submit"
          (click)="completeSetup()">
          Confirm
        </button>
      </div>
    }
  </bn-web-ui-steps-component>
</div>
